import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import AdminCompanyList from "./pages/AdminCompanyList"
import AdminCompanyCards from "./pages/AdminCompanyCards"
import AddNewCompany from "./pages/AddNewCompany"
import AdminLogin from "./pages/AdminLogin"
import AdminSupport from "./pages/AdminSupport"
import { ProtectedRoute } from "./components/ProtectedRoute"

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/" element={<Navigate to="/admin/login" replace />} />

        {/* Protected Admin Routes */}
        <Route path="/admin" element={<ProtectedRoute element={<AdminCompanyList />} />} />
        <Route path="/admin/company-list" element={<ProtectedRoute element={<AdminCompanyList />} />} />
        <Route path="/admin/company-card-view-list" element={<ProtectedRoute element={<AdminCompanyCards />} />} />
        <Route path="/admin/add-new-company" element={<ProtectedRoute element={<AddNewCompany />} />} />
        <Route path="/admin/support" element={<ProtectedRoute element={<AdminSupport />} />} />

        {/* 404 Fallback */}
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </Router>
  )
}
